module.exports = {"id":"226539","name":"Younes Namli","rating":"73","photo":"./data/images/photos/1/226539.png","club":{"name":"PEC Zwolle","logo":"./data/images/clubs/PECZwolle.png"},"positions":["MD","MC","MOC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YounesNamli0.json
// module id = 4430
// module chunks = 0